import { HttpEvent, HttpHandlerFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { HttpMethod } from '@app/core/enums/http-method.enum';
import { CSRF_CONFIG } from '@app/core/configs/http.config';
import { CsrfTokenService } from './csrf-token.service';

export function csrfTokenInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const csrfTokenService = inject(CsrfTokenService);
  const method = request.method as HttpMethod;

  const isModifyingMethod = [HttpMethod.POST, HttpMethod.PUT, HttpMethod.DELETE].includes(method);
  const modifiedRequest = isModifyingMethod ? addCsrfToken(request, csrfTokenService) : request;

  return next(modifiedRequest).pipe(
    tap(event => {
      if (event instanceof HttpResponse) {
        const csrfToken = event.headers.get(CSRF_CONFIG.HEADER_NAME);
        if (csrfToken) {
          csrfTokenService.setToken(csrfToken);
        }
      }
    })
  );
}

function addCsrfToken(request: HttpRequest<unknown>, csrfTokenService: CsrfTokenService): HttpRequest<unknown> {
  const token = csrfTokenService.getToken();

  if (!token) {
    return request;
  }

  return request.clone({
    setHeaders: { [CSRF_CONFIG.HEADER_NAME]: token },
  });
}
